import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/navbar/index.jsx';
import Footer from '../../components/Footer/Footer.js';
import WaFloat from '../../components/WaFloat/WaFloat.jsx';
import { useReveal } from '../../hooks/useReveal.js';
import ceoImg from '../../assets/images/gallery/15.jpeg';

export default function About() {
  useReveal();
  return (
    <>
      <Navbar />

      {/* HERO */}
      <div className="page-hero about-hero">
        <div className="about-hero-wrap">
          <div className="page-hero-inner">
            <span className="sec-tag reveal">About AQT Direct</span>
            <h2 className="sec-h reveal" style={{ maxWidth: 560 }}>
              Advisory for Promoters,<br />Investors &amp; <em>Growth Enterprises.</em>
            </h2>
            <p className="sec-sub reveal reveal-delay-1">
              AQT Direct Limited is a strategic advisory firm working at the intersection of capital, strategy, and business growth — serving select promoters, family offices, growth companies, and institutional investors across India and strategic global markets.
            </p>
          </div>
          <div className="about-hero-img reveal reveal-delay-1">
            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80"
              alt="Corporate advisory"
            />
          </div>
        </div>
      </div>

      {/* WHO WE WORK WITH */}
      <section className="section">
        <div className="grid-2">
          <div>
            <span className="sec-tag reveal">Our approach</span>
            <h2 className="sec-h reveal">How we work.<br /><em>What sets us apart.</em></h2>
            <p className="sec-sub reveal reveal-delay-1">
              We are not a brokerage. We are not a bank. We are advisors — senior, experienced professionals who bring decades of institutional knowledge to bear on the problems that matter most to our clients.
            </p>
            <p className="sec-sub reveal reveal-delay-1" style={{ marginTop: 12 }}>
              Our model is selective, senior-led, confidential, and outcome-focused. We choose our engagements carefully. That is the source of our value.
            </p>
          </div>
          <div className="who-list reveal reveal-delay-1">
            {[
              { n: '01', h: 'Promoters & Founders', p: 'Growth-stage businesses seeking capital advisory, investor introductions, or strategic structuring support for the next phase of growth.' },
              { n: '02', h: 'Family Offices', p: 'Single and multi-family offices seeking curated, structured access to private investment opportunities in India\'s mid-market.' },
              { n: '03', h: 'Growth Companies', p: 'Established businesses with ₹20 Cr+ revenue planning significant capital events, expansions, or strategic transactions.' },
              { n: '04', h: 'Private Investors', p: 'HNIs seeking structured, advisory-led access to pre-market investment opportunities with a long-term perspective.' },
              { n: '05', h: 'Cross-border Opportunities', p: 'International businesses exploring India entry or Indian businesses seeking international capital and strategic partnerships.' },
            ].map(({ n, h, p }) => (
              <div className="who-item" key={n}>
                <span className="who-num">{n}</span>
                <div className="who-content"><h4>{h}</h4><p>{p}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <hr className="rule" />

      {/* PRINCIPLES */}
      <section className="section section-off">
        <span className="sec-tag reveal">Our principles</span>
        <div className="grid-2 grid-2-center">
          <div>
            <h2 className="sec-h reveal">How we work.<br /><em>Why it matters.</em></h2>
          </div>
          <div className="why-points reveal reveal-delay-1">
            {[
              { h: 'Confidentiality as a foundation', p: 'We do not discuss our clients, our mandates, or our transactions publicly. Your engagement with us is private.' },
              { h: 'No guaranteed outcomes', p: 'We are honest about what advisory is and is not. We do not promise funding, approvals, or returns. We provide expert guidance, structured introductions, and disciplined execution.' },
              { h: 'Senior at every stage', p: 'Our principals lead every engagement. There is no junior delegation of strategy or client relationships.' },
              { h: 'India-focused. Globally aware.', p: 'Our core expertise is the Indian mid-market. Our networks extend to international capital and strategic partners.' },
            ].map(({ h, p }) => (
              <div className="why-pt" key={h}>
                <div className="why-pt-mark" />
                <div className="why-pt-body"><h4>{h}</h4><p>{p}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LEADERSHIP */}
      {/* <section className="section leader-section" style={{ position: 'relative', overflow: 'hidden' }}>
        <div className="page-hero-dark-bg" style={{ width: '36%', opacity: 0.6 }} />
        <span className="sec-tag reveal">Leadership</span>
        <div className="leader-grid">
          <div className="leader-portrait reveal">
            <img src={ceoImg} alt="Shalini Misra – CEO & Director" />
          </div>
          <div className="leader-content">
            <div className="leader-name reveal">Shalini Misra</div>
            <div className="leader-title reveal">CEO &amp; Director</div>
            <p className="leader-bio reveal reveal-delay-1">
              Shalini brings over 23 years of institutional experience across leading Indian and global financial institutions. Her career spans risk management, credit, banking operations, and business strategy—providing AQT Direct with a strong foundation of analytical rigor, execution discipline, and institutional perspective.
            </p>
            <p className="leader-bio reveal reveal-delay-1">
              At AQT Direct, she leads client engagements, capital strategy, and transaction execution. She works closely with business leaders and investors to structure capital solutions aligned with long-term value creation.
            </p>
            <p className="leader-bio reveal reveal-delay-1">
              Her prior experience includes senior roles across global and domestic institutions:
            </p>
            <div className="cred-list reveal reveal-delay-2">
              {[
                'Executive Director — JP Morgan',
                'Vice President — Morgan Stanley',
                'Vice President/ Chief Manager — State Bank of India',
              ].map(c => (
                <div className="cred-item" key={c}>
                  <div className="cred-dot" />
                  <span className="cred-text">{c}</span>
                </div>
              ))}
            </div>
            <p className="leader-bio reveal reveal-delay-2" style={{ marginTop: 8 }}>
              Shalini holds an Executive MBA from the Indian Institute of Management, Ahmedabad, and is a Certified Independent Director accredited by the Indian Institute of Corporate Affairs (Ministry of Corporate Affairs).
            </p>
            <p className="leader-bio reveal reveal-delay-2">
              She is also associated with advisory initiatives in economic and social sectors.
            </p>
            <div className="reveal reveal-delay-3">
              <a href="https://www.linkedin.com/in/shalini-misra-32854919/" target="_blank" rel="noopener noreferrer" className="btn-white-outline">
                LinkedIn Profile →
              </a>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA */}
      <div className="cta-strip reveal">
        <h2>We work with few clients.<br /><em>For good reason.</em></h2>
        <p>Selective engagement is how we protect quality. If you believe there is a basis for a conversation, we invite you to reach out privately.</p>
        <div className="cta-btns">
          <Link className="btn-white" to="/contactus">Register Interest</Link>
        </div>
      </div>

      <Footer />
      <WaFloat />
    </>
  );
}
